<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <b-row v-if="item">
        <b-col>
          <router-link :to="{ name: 'EXCMConsentUpdate', params: { id: item['@id'] }}" class="btn btn-default">{{$t('buttons.edit')}}</router-link>
<!--          <button class="btn btn-danger" @click="deleteItem(item)">{{ $t('buttons.delete') }}</button>-->
          <button class="btn btn-warning" @click="archiveItem(item)">{{ $t('buttons.archive') }}</button>
          <router-link :to="{ name: 'EXCMConsentList' }" class="btn btn-default float-right">{{$t('buttons.backToList')}}</router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <div class="card-header">
              <h4 class="card-title">{{$t('views.excmconsent.show.title')}}</h4>
            </div>
            <div class="card-body">
              <b-row>
                <b-col>
                  <p>
                    <b>{{$t('views.excmconsent.show.name')}}:</b> {{ item['title'] }}<br>
                    <span v-if="item['agreementType']"><b>{{$t('views.excmconsent.show.agreementType')}}:</b>  {{ item['agreementType'].title }}<br></span>
                    <b>{{$t('views.excmconsent.show.description')}}:</b> {{ item['description'] }}<br>
                    <b>{{$t('views.excmconsent.show.orderConsent')}}:</b> {{ item['orderConsent'] }}<br>
                    <b>{{$t('views.excmconsent.show.requireConsent')}}: </b> <span v-if="item['requireConsent'] === 0">{{ $t('buttons.no') }}</span><span v-else-if="item['requireConsent'] === 1">{{ $t('buttons.yes') }}</span><br>
                    <b>{{$t('views.consents.list.showOnAgreement')}}: </b> <span v-if="item['showOnAgreement'] === 0">{{ $t('buttons.no') }}</span><span v-else-if="item['showOnAgreement'] === 1">{{ $t('buttons.yes') }}</span><br>
                    <b>{{$t('views.consents.list.showOnAgreementSign')}}: </b> <span v-if="item['showOnAgreementSign'] === 0">{{ $t('buttons.no') }}</span><span v-else-if="item['showOnAgreementSign'] === 1">{{ $t('buttons.yes') }}</span><br>
                    <b>{{$t('views.consents.list.showOnAgreementAccept')}}: </b> <span v-if="item['showOnAgreementAccept'] === 0">{{ $t('buttons.no') }}</span><span v-else-if="item['showOnAgreementAccept'] === 1">{{ $t('buttons.yes') }}</span><br>
                    <b>{{$t('views.consents.list.showOnline')}}: </b> <span v-if="item['showOnline'] === 0">{{ $t('buttons.no') }}</span><span v-else-if="item['showOnline'] === 1">{{ $t('buttons.yes') }}</span><br>
                    <b>{{$t('views.consents.form.consentType')}}: </b> <span v-if="item['consentType'] === 0">{{ $t('views.consents.form.forAgreement') }}</span><span v-else-if="item['consentType'] === 1">{{ $t('views.consents.form.forSla') }}</span><br>
                  </p>
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Loader from '../../Layout/Loader'
import getId from '@/utils/getIdFromLink'

export default {
  computed: mapGetters({
    deleteError: 'excmconsent/del/error',
    error: 'excmconsent/show/error',
    isLoading: 'excmconsent/show/isLoading',
    item: 'excmconsent/show/retrieved'
  }),

  components: {
    Loader
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      del: 'excmconsent/del/del',
      reset: 'excmconsent/show/reset',
      retrieve: 'excmconsent/show/retrieve'
    }),

    archiveItem (item) {
      this.$Swal({
        title: this.$t('notifications.archiveTitle') + ' ' + this.$t('notifications.archiveDescription'),
        type: 'question',
        showConfirmButton: true,
        confirmButtonText: this.$t('buttons.yes'),
        showCancelButton: true,
        cancelButtonText: this.$t('buttons.cancel')
      }).then((result) => {
        if (result) {
          this.$http
            .put('api/e_x_c_m_consents/' + this.getIdLink(this.item['@id']), {
              state: 0
            })
            .then(response => {
              this.$router.push({ name: 'EXCMConsentList' })
              this.$Swal({ // show notification with success
                type: 'success',
                title: this.$t('notifications.update.updatedTitle'),
                showConfirmButton: false,
                timer: 2500
              })
            })
            .catch(error => {
              if (error.response.status === 400) {
                let text = ''
                for (let i in error.response.data) {
                  text += error.response.data[i] + '\n'
                }
                this.$Swal({
                  type: 'warning',
                  title: text,
                  timer: 2500
                })
              }
              console.log(error)
            })
        }
      })
    },

    getIdLink (link) {
      return getId(link)
    },

    deleteItem (item) {
      this.$Swal({
        title: this.$t('notifications.deleteTitle'),
        type: 'question',
        showConfirmButton: true,
        confirmButtonText: this.$t('buttons.yes'),
        showCancelButton: true,
        cancelButtonText: this.$t('buttons.cancel')
      }).then((result) => {
        if (result.value) {
          this.del(item).then(() => this.$router.push({ name: 'EXCMConsentList' }))
        }
      })
    }
  }
}
</script>
